module.exports = __webpack_public_path__ + "img/user-challenge.8ca60306.svg";